export const SET_TITLE = 'SET_TITLE';
export const SET_REPORT = 'SET_REPORT';
export const SET_REPORT_DATA = 'SET_REPORT_DATA';
export const SET_SAVING = 'SET_SAVING';
export const SET_FEEDBACK_SAVED = 'SET_FEEDBACK_SAVED';
export const SET_FEEDBACK_SAVING = 'SET_FEEDBACK_SAVING';
export const SET_MODAL_OPEN = 'SET_MODAL_OPEN';
export const SET_SHARE_MODAL_OPEN = 'SET_SHARE_MODAL_OPEN';
export const SET_REPORT_SHARE = 'SET_REPORT_SHARE';

const DEFAULT_TITLE = 'Untitled Report';

const now = () => new Date().toISOString();

export const initialState = {
  feedback: ' ',
  modalOpen: false,
  touched: false,
  shareModalOpen: false,
  report: {
    reportData: '',
    title: DEFAULT_TITLE,
    id: '',
    shareEnabled: false,
    shareCode: '',
    sharePassword: '',
  },
};

const reducer = (state, action) => {
  switch (action.type) {
    case SET_REPORT: {
      const { report } = action.payload;
      const {
        reportData,
        name,
        id,
        shareCode,
        sharePassword,
        shareEnabled,
        testSessionNotes = [],
        highlightReels = [],
      } = report;
      return {
        ...state,
        report: {
          reportData,
          title: name,
          id,
          shareCode,
          shareEnabled,
          sharePassword,
          testSessionNotes,
          highlightReels,
        },
      };
    }
    case SET_REPORT_DATA: {
      const { reportData } = action.payload;
      return {
        ...state,
        report: {
          ...state.report,
          reportData,
        },
      };
    }
    case SET_TITLE: {
      const { title } = action.payload;
      return {
        ...state,
        report: {
          ...state.report,
          title,
        },
      };
    }
    case SET_FEEDBACK_SAVING: {
      const { feedback, touched } = action.payload;
      return {
        ...state,
        feedback,
        touched,
      };
    }
    case SET_SAVING: {
      return {
        ...state,
        savedAt: now(),
      };
    }
    case SET_FEEDBACK_SAVED: {
      const { feedback, touched } = action.payload;
      return {
        ...state,
        feedback,
        touched,
      };
    }
    case SET_MODAL_OPEN: {
      const { modalOpen } = action.payload;
      return {
        ...state,
        modalOpen,
      };
    }
    case SET_SHARE_MODAL_OPEN: {
      const { shareModalOpen } = action.payload;
      return {
        ...state,
        shareModalOpen,
      };
    }
    default:
      return state;
  }
};

export default reducer;
